import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_2 = { class: "text-sm text-gray-300 pb-3 border-b border-gray-700" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "Colis :", -1)
const _hoisted_4 = { class: "ml-1 text-white font-medium" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "Destinataire :", -1)
const _hoisted_7 = { class: "ml-1 text-white" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col gap-3 p-3 rounded border border-amber-700/40 bg-amber-900/10"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-amber-300 text-xs uppercase font-semibold" }, " 🔒 Livraison déjà enregistrée — trace immuable ", -1)
const _hoisted_10 = { class: "grid grid-cols-2 gap-3 text-sm" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Reçu par", -1)
const _hoisted_12 = { class: "text-white" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs" }, "Date / heure", -1)
const _hoisted_14 = { class: "text-white" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs mb-1" }, "Signature", -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-xs mb-1" }, "Photo", -1)
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400 italic" }, " La preuve de livraison ne peut pas être modifiée pour préserver la chaîne d'audit. Pour signaler une erreur, contactez un administrateur. ", -1)
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300 text-sm mb-1" }, [
  /*#__PURE__*/_createTextVNode("Reçu par "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "(*)")
], -1)
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300 text-sm mb-1" }, [
  /*#__PURE__*/_createTextVNode("Signature "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "(*)")
], -1)
const _hoisted_26 = { class: "flex flex-col" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300 text-sm mb-1" }, "Photo (optionnelle)", -1)
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "inline-flex items-center gap-2 px-4 py-2 bg-secondary border border-gray-600 rounded cursor-pointer hover:border-gray-400 text-sm text-gray-300" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "Choisir une photo", -1)
const _hoisted_31 = {
  key: 1,
  class: "relative inline-block"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "flex flex-row items-end justify-end w-full space-x-2" }

import api from "@/api";
	import useNotyf from "@/composable/useNotyf";
	import { onMounted, ref, computed } from "vue";
	import { getApiBaseUrl } from "@/config/runtime";
	import SignaturePad from "@/components/widgets/SignaturePad.vue";

	const modalName = "DeliveryProofModal";
	
export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryProofModal',
  props: {
    pkg: {}
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

	/**
	 * Delivery proof capture: receiver name + signature canvas + optional
	 * photo. Posts a multipart form to /operation/packages/delivery-proof
	 * which stamps proof_signature_path, proof_photo_path, delivered_at,
	 * delivered_to on the package and marks it as picked-up.
	 */
	const props = __props;
	const emit = __emit;

	const notify = useNotyf();
	const deliveredTo = ref<string>(props.pkg?.delivered_to ?? "");
	const signature = ref<string>("");
	const photoFile = ref<File | null>(null);
	const photoPreview = ref<string>(props.pkg?.proof_photo_path ?? "");
	const submitting = ref(false);

	// Once a delivery is on file, the modal switches to a read-only
	// audit-trail view. Overwriting would erase the original signature
	// + receiver name, which defeats the proof-of-delivery purpose.
	// `serverConflict` is set when the backend returns 409 — the parent
	// `pkg` object may not have the delivery fields populated yet, but
	// the 409 payload does, so we render the read-only view from it.
	const serverConflict = ref<{
		delivered_to?: string;
		delivered_at?: string;
		proof_signature_path?: string | null;
		proof_photo_path?: string | null;
	} | null>(null);

	const isAlreadyDelivered = computed(
		() => !!props.pkg?.delivered_at || !!serverConflict.value
	);

	// Backend returns proof paths as relative URLs (`/storage/...`).
	// They live on the API host (e.g. localhost:8000), not the front
	// dev server (localhost:8085) — so we must prepend VUE_APP_API for
	// the <img src> to resolve correctly. Absolute URLs are passed
	// through unchanged.
	const absoluteUrl = (path?: string | null): string => {
		if (!path) return "";
		if (/^https?:\/\//.test(path)) return path;
		const base = getApiBaseUrl().replace(/\/+$/, "");
		const rel = path.startsWith("/") ? path : "/" + path;
		return base + rel;
	};

	const proofView = computed(() => ({
		delivered_to: serverConflict.value?.delivered_to ?? props.pkg?.delivered_to,
		delivered_at: serverConflict.value?.delivered_at ?? props.pkg?.delivered_at,
		proof_signature_path: absoluteUrl(
			serverConflict.value?.proof_signature_path ?? props.pkg?.proof_signature_path
		),
		proof_photo_path: absoluteUrl(
			serverConflict.value?.proof_photo_path ?? props.pkg?.proof_photo_path
		),
	}));

	const fmtDate = (d?: string | null) => {
		if (!d) return "—";
		try {
			return new Date(d).toLocaleString("fr-FR", { dateStyle: "long", timeStyle: "short" });
		} catch { return String(d); }
	};

	/**
	 * Convert a remote image URL to a base64 data URL so the SignaturePad
	 * can paint it into the canvas. Avoids a CORS leak by always reading
	 * via fetch + FileReader (works for our same-origin /storage paths).
	 */
	const urlToDataUrl = async (url: string): Promise<string> => {
		try {
			const res = await fetch(url, { credentials: "include" });
			if (!res.ok) throw new Error("HTTP " + res.status);
			const blob = await res.blob();
			return await new Promise<string>((resolve, reject) => {
				const r = new FileReader();
				r.onload = () => resolve(r.result as string);
				r.onerror = reject;
				r.readAsDataURL(blob);
			});
		} catch (e) {
			console.warn("[DeliveryProofModal] cannot fetch existing signature", e);
			return "";
		}
	};

	// No on-mount preload of the signature into the canvas: when the
	// package is already delivered we render the proof read-only via
	// the audit-trail block (see template) instead of loading it into
	// the editable SignaturePad.

	const canSubmit = computed(() =>
		deliveredTo.value.trim().length >= 2 && signature.value.length > 0 && !submitting.value
	);

	const onPhotoSelected = (e: Event) => {
		const f = (e.target as HTMLInputElement).files?.[0];
		if (!f) return;
		photoFile.value = f;
		const reader = new FileReader();
		reader.onload = () => { photoPreview.value = reader.result as string; };
		reader.readAsDataURL(f);
	};

	const removePhoto = () => {
		photoFile.value = null;
		photoPreview.value = "";
	};

	const submit = async () => {
		if (!canSubmit.value) return;
		submitting.value = true;
		try {
			const fd = new FormData();
			fd.append("package", props.pkg.uuid);
			fd.append("delivered_to", deliveredTo.value.trim());
			fd.append("signature", signature.value);
			if (photoFile.value) fd.append("photo", photoFile.value);

			const res: any = await api().packages.confirmDelivery(fd);
			notify.success("Livraison confirmée");
			emit("success", res?.data || null);
			emit("close");
		} catch (err: any) {
			// 409 means the package was already delivered. Don't burn the
			// user's signature — flip to the read-only proof view using
			// the existing trace returned in the response payload.
			const status = err?.response?.status ?? err?.status;
			const payload = err?.response?.data?.data ?? err?.data?.data ?? err?.data ?? null;
			if (status === 409 && payload) {
				serverConflict.value = {
					delivered_to: payload.delivered_to,
					delivered_at: payload.delivered_at,
					proof_signature_path: payload.proof_signature_path,
					proof_photo_path: payload.proof_photo_path,
				};
				notify.warning("Cette livraison a déjà été enregistrée — affichage de la trace existante.");
			} else {
				console.warn(err);
				notify.error("Échec de la confirmation de livraison");
			}
		} finally {
			submitting.value = false;
		}
	};

	const onModalClose = (e: any) => {
		if (e === modalName) emit("close");
	};

return (_ctx: any,_cache: any) => {
  const _component_InputTag = _resolveComponent("InputTag")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_ModalPage = _resolveComponent("ModalPage")!

  return (_openBlock(), _createBlock(_component_ModalPage, {
    title: isAlreadyDelivered.value ? 'Preuve de livraison enregistrée' : 'Confirmer la livraison',
    name: modalName,
    styleContent: "w-full",
    styleFooter: "w-full",
    onClose: onModalClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.pkg?.reference), 1)
          ]),
          _createElementVNode("p", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.pkg?.recipient?.first_name) + " " + _toDisplayString(_ctx.pkg?.recipient?.last_name), 1)
          ])
        ]),
        (isAlreadyDelivered.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, [
                  _hoisted_11,
                  _createElementVNode("p", _hoisted_12, _toDisplayString(proofView.value.delivered_to || '—'), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_13,
                  _createElementVNode("p", _hoisted_14, _toDisplayString(fmtDate(proofView.value.delivered_at)), 1)
                ])
              ]),
              (proofView.value.proof_signature_path)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("img", {
                      src: proofView.value.proof_signature_path,
                      alt: "signature",
                      class: "max-h-40 rounded border border-gray-600 bg-white"
                    }, null, 8, _hoisted_17)
                  ]))
                : _createCommentVNode("", true),
              (proofView.value.proof_photo_path)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("img", {
                      src: proofView.value.proof_photo_path,
                      alt: "photo",
                      class: "max-h-40 rounded border border-gray-600"
                    }, null, 8, _hoisted_20)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_21
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_InputTag, {
                  type: "text",
                  placeholder: "Nom et prénom du récepteur",
                  value: deliveredTo.value,
                  onModel: _cache[0] || (_cache[0] = (e) => deliveredTo.value = e)
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(SignaturePad, {
                  modelValue: signature.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((signature).value = $event)),
                  width: 540,
                  height: 160
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                (!photoPreview.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/*",
                          capture: "environment",
                          class: "hidden",
                          onChange: onPhotoSelected
                        }, null, 32)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("img", {
                        src: photoPreview.value,
                        alt: "aperçu",
                        class: "max-h-32 rounded border border-gray-600"
                      }, null, 8, _hoisted_32),
                      _createElementVNode("button", {
                        type: "button",
                        class: "absolute top-1 right-1 bg-red-500 hover:bg-red-700 text-white text-xs px-2 py-0.5 rounded focus:outline-none",
                        onClick: removePhoto
                      }, "×")
                    ]))
              ])
            ], 64))
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_ButtonTag, {
          label: isAlreadyDelivered.value ? 'Fermer' : 'Annuler',
          activeIcon: false,
          css: "bg-gray-500 border-secondary text-white px-6 py-2 hover:bg-gray-600 focus:outline-none",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
        }, null, 8, ["label"]),
        (!isAlreadyDelivered.value)
          ? (_openBlock(), _createBlock(_component_ButtonTag, {
              key: 0,
              label: "Confirmer la livraison",
              loader: submitting.value,
              "text-loading": "Envoi…",
              disabled: !canSubmit.value,
              css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] focus:outline-none disabled:opacity-50",
              onClick: submit
            }, null, 8, ["loader", "disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})